const clipperCtasCtes = {
  'Ctas Ctes': [
    {
      type: 'section',
      iconKey: 'usuarios',
      label: 'Cuentas Corrientes de Clientes',
      items: [
        { label: 'Resumen de Cuenta', to: '/ctasctes/cuenta-corriente-clientes/resumen-de-cuenta', iconKey: 'reportes' },
        { label: 'Deuda de Clientes', to: '/ctasctes/cuenta-corriente-clientes/deuda-de-clientes', iconKey: 'reportes', permissions: 'CUENTA_CORRIENTE_GENERAR_PDF' },
        { label: 'Consulta Créditos y Débitos', to: '/ctasctes/cuenta-corriente-clientes/consulta-creditos-y-debitos', iconKey: 'busqueda' },
        { label: 'Ajustes de Saldo', to: '/ctasctes/cuenta-corriente-clientes/ajustes-de-saldo', iconKey: 'ajustes' },
      ],
    },
    {
      type: 'section',
      iconKey: 'facturacion',
      label: 'Facturación y Fiscal',
      items: [
        { label: 'Subdiario IVA Ventas', to: '/ctasctes/facturacion-y-fiscal/subdiario-iva-ventas', iconKey: 'notas' },
        { label: 'Exportacion ARCA', to: '/ctasctes/facturacion-y-fiscal/exportacion-arca', iconKey: 'reportes' },
        { label: 'Percepciones Emitidas', to: '/ctasctes/facturacion-y-fiscal/percepciones-emitidas', iconKey: 'comprobantes' },
        { label: 'Régimen Compras y Ventas - RG 3685', to: '/ctasctes/facturacion-y-fiscal/regimen-compras-ventas-rg-3685', iconKey: 'reportes' },
      ],
    },
    {
      type: 'section',
      iconKey: 'tesoreria',
      label: 'Contrareembolsos',
      items: [
        { label: 'Consultas de Contrareembolsos', to: '/tesoreria/cobranzas/seguimiento-de-contrareembolsos-cobrados', iconKey: 'busqueda' },
      ],
    },
  ],
};

export default clipperCtasCtes;
